import {createTheme} from '@material-ui/core';

// const themeMaterialUI = createTheme({
//   overrides: {
//     MuiButton: {
//       label: {
//         color: 'black'
//       },
//       root: {
//         borderRadius: '0px'
//       },
//     },
//     MuiSnackbarContent: {
//       root: {
//         backgroundColor: 'rgb(255, 244, 229)',
//       }
//     },
//     MuiRating: {
//       iconFilled: {
//         color: '#8acdc8',
//       },
//       iconHover: {
//         color: '#ffb400',
//       },
//     },
//   },
//   typography: {
//     fontFamily: '"Segoe UI"',
//   },
//   palette: {
//     primary: {
//       main: '#2cb8ad',
//       oldMain: '#2cb8ad',
//       item:'#8acdc8',
//       cell: '#2CB8AC',
//       100: '#75bab8',
//       50: '#8fdfdc',
//       newMain: '#0c4c4c',
//       newItem: '#eef9f9'
//     },
//     green: {
//       dark: 'black'
//     },
//     blue: {
//       dark: 'black'
//     },
//     colors: {
//       text: '#0c4c4c'
//     },
//   secondary: {
//       main: '#ffc100',
//       item: 'rgba(255, 193, 0, 0.5)',
//   },
//     error: {
//       main: '#A02929',
//       light: '#e41e15',
//     },
//     header: {
//       main: '#fafafa',
//     },
//     star: {
//       color: '#ffb400',
//     },
//   },
// });
//
// export default themeMaterialUI;

const themeMaterialUI = createTheme ({
  overrides: {
    MuiPopover: {
      paper: {
        borderRadius: "10px"
      }
    },
    MuiInputBase: {
      root: {
        "& input::placeholder": {
          fontSize: "15px",
          fontWeight: 400
        },
        "& textarea::placeholder": {
          fontSize: "15px",
          fontWeight: 400
        },
      }
    },
    MuiList: {
      padding: {
        paddingTop: 0,
        paddingBottom: 0
      }
    },
    MuiSelect: {
      select: {
        '&:focus': {
          backgroundColor: 'transparent'
        }
      }
    }
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeightRegular: 600,
  },
  palette: {
    colors: {
      main: '#144c7b',
      error: '#E41E15',
      secondary: '#BD90C7',
      dark: '#0F0F0F',
      text: '#0E4E4E',
      light: '#C5C6C6',
      darkLight: '#18243E',
      border: '#F0F0F0',
    },
    primary: {
      main: '#144c7b',
      dark: '#0D314F',
      light: '#144c7b26',
      lighter: '#144c7b40'
    },
    secondary: {
      main: '#BD90C7',
    },
    error: {
      main: '#E41E15',
    },
    dark: {
      main: '#0F0F0F',
    },
    grey: {
      main: '#C5C6C6',
      text: '#9A9EA6',
      border: '#F0F0F0',
      label: '#0F0F0F80',
      accordion: '#363D4D14',
      price: '#363D4D',
      light: '#F0F0F0FF',
      action: '#707070',
    },
    blue: {
      main: '#18243E',
      light: '#18243E80',
      calendar: '#18243E1a'
    },
    header: {
      main: '#fffff',
    },
    green: {
      dark: '#0E4E4E',
      lighter: '#0E4E4EB3',
      calendar: '#0E4E4E80',
      actions: '#0B4040'
    },
  },
});

export default themeMaterialUI;